import { render } from "./Mo_modal_max_force.vue?vue&type=template&id=48e38534&scoped=true&ts=true"
import script from "./Mo_modal_max_force.vue?vue&type=script&lang=ts"
export * from "./Mo_modal_max_force.vue?vue&type=script&lang=ts"

import "./Mo_modal_max_force.vue?vue&type=style&index=0&id=48e38534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e38534"]])

export default __exports__